import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
} from '@mui/material';

function Navbar({ user, onSignOut }) {
  // User info and sign out moved to sidebar


  return (
    <>

    </>
  );
}

export default Navbar;